module.exports = __webpack_public_path__ + "img/fullpayment_status.de6afa8a.svg";